import request from '@/request'
const state = {
    metadata: null
}
const mutations = {
    SET_METADATA: (state, metadata) => {
        state.metadata = metadata
    },
}
const actions = {
    getMetadata({ commit }) {
        return new Promise((resolve, reject) => {
          request({
            url: '/metadata',
            method: 'get',
            // param: {token: getToken()}
          }).then(response => {
              const storage  = response.data
              // setCookieMetadata(JSON.stringify(storage))
              commit('SET_METADATA', storage)
              resolve(storage)
            })
            .catch(error => {
              console.log(error)
              reject(error)
            })
          })
      },
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}